import { render, staticRenderFns } from "./CartaoDeListaDeReferencia.vue?vue&type=template&id=7fdff487&scoped=true"
import script from "./CartaoDeListaDeReferencia.vue?vue&type=script&setup=true&lang=js"
export * from "./CartaoDeListaDeReferencia.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CartaoDeListaDeReferencia.vue?vue&type=style&index=0&id=7fdff487&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fdff487",
  null
  
)

export default component.exports